import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TasksStatusComponent } from './tasks-status.component';
import { MatCardModule } from '@angular/material/card';
import { TasksStatusSummaryComponent } from './summary/tasks-status-summary.component';
import { TasksStatusInProgressComponent } from './in-progress/tasks-status-in-progress.component';
import { TasksStatusCompletedComponent } from './completed/tasks-status-completed.component';
import { TasksStatusArchivedComponent } from './archived/tasks-status-archived.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatSortModule } from '@angular/material/sort';
import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatSortModule,
        MatTableModule,
        FiAppTextSharedModule,
        FiWrapperTableModule,
        FiFormatDateModule,
        FiChartModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
    ],
    declarations: [
        TasksStatusComponent,
        TasksStatusSummaryComponent,
        TasksStatusInProgressComponent,
        TasksStatusCompletedComponent,
        TasksStatusArchivedComponent,
    ],
    exports: [TasksStatusComponent],
})
export class TasksStatusModule {}
